import { API } from "@/api/api";
import { makePostRequest } from "@/api/fetchCalls";
import { RolePayloadModel } from "@/domain/model/roles";

const addNewRole = async (data: RolePayloadModel) => {
  return (await makePostRequest(API.PERMISSIONS.MEMBERSHIP_GROUPS, {
    body: JSON.stringify(data),
  })) as Promise<void>;
};

export default addNewRole;
